import React from "react";
import PropsTypes from "prop-types";
import { CloseButton } from "@learningblocks/shared-components/lib/CloseButton";
import { GlossaryComponent as Glossary } from "@learningblocks/storybook-components/lib/GlossaryComponent";

import { GlossaryDispatch } from "../index";

import style from "./style.module.scss";

/**
 *  GlossaryTab:
 *      Glossary Content to be displayed in tab view
 */
export function GlossaryTab(props) {
  const { state, onFetchGlossary, onFetchGlossaryItem } =
    React.useContext(GlossaryDispatch);

  const onSearch = (event) => {
    event.preventDefault();
    onFetchGlossary();
  };

  const isGlossaryEmpty = React.useMemo(() => {
    return state.glossaryList.length <= 0;
  }, [state.glossaryList.length]);

  const renderIndexExpanded = () => (
    <div className={style.glossary_left}>
      <div className={style.glossary_left_header}>
        <div className={style.glossary_left_header_logo}>
          <Glossary.GlossaryLogo />
          <Glossary.ChevronIcon className={style.glossary_left_chevron} />
        </div>
        <Glossary.SearchBox>
          <Glossary.SearchInput
            value={state.searchText}
            onEnterKey={onSearch}
          />
          <Glossary.SearchIcon onClick={onSearch} />
        </Glossary.SearchBox>
        <Glossary.CategoryDropdown categories={state.categories} />
      </div>
      <div className={style.glossary_left_body}>
        <Glossary.GlossaryListBlock
          {...state.listApi}
          onRetry={onSearch}
          isEmpty={isGlossaryEmpty}
        >
          <Glossary.GlossaryListing glossaryList={state.glossaryList} />
        </Glossary.GlossaryListBlock>
      </div>
    </div>
  );

  const renderIndexCollapsed = () => (
    <div className={style.glossary_left__collapsed}>
      <Glossary.IndexCollapsed />
    </div>
  );

  const renderIndex = () =>
    state.indexCollapsed ? renderIndexCollapsed() : renderIndexExpanded();

  return (
    <div className={style.glossary}>
      {renderIndex()}
      <div className={style.glossary_right}>
        <CloseButton
          close={props.closeGlossary}
          className={style.glossary_right_closeButton}
        />
        <Glossary.DetailsBlock
          {...state.contentApi}
          onRetry={() => onFetchGlossaryItem(state.selected)}
        >
          <Glossary.GlossaryDetails {...state.glossaryItem} />
        </Glossary.DetailsBlock>
      </div>
    </div>
  );
}

GlossaryTab.propsTypes = {
  /**
   * function to close glossary modal window
   */
  closeGlossary: PropsTypes.func,
};
